import Carvana from './carvana.png';
import Devacurl from './devacurl.png';
import Fox from './fox.png';
import Intuit from './intuit.png';
import Kiva from './kiva.png';
import Lonelyplanet from './lonelyplanet.png';
import Target from './target-logo.png';

export const brandLogo = {
  Carvana,
  Devacurl,
  Fox,
  Intuit,
  Kiva,
  Lonelyplanet,
  Target,
};
